export const STACK_NAME = process.env.REACT_APP_STACKNAME;
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
export const FLOODLIGHT_ID = process.env.REACT_APP_FLOODLIGHT_ID;
